import { render, staticRenderFns } from "./DQCustomerShippingmark.vue?vue&type=template&id=126f3326&scoped=true&"
import script from "./DQCustomerShippingmark.vue?vue&type=script&lang=js&"
export * from "./DQCustomerShippingmark.vue?vue&type=script&lang=js&"
import style0 from "./DQCustomerShippingmark.vue?vue&type=style&index=0&id=126f3326&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126f3326",
  null
  
)

export default component.exports